import { Component } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { GeneralComponent } from '../../General/g.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { Graph } from '../../General/graph/lib/graph';
import { TreeWords } from './tree-words';
import { ColoredFlagRep } from './colored-flag-rep';
import { ColoredFlagNoRep } from './colored-flag-no-rep';
import { TreeService } from '../../General/Tree/tree.service';
import { TreeNode } from '../../General/Tree/lib/tree-node';
import { MultiSetTreeNode } from '../../General/Tree/MultiSet/multi-set-tree-node';

@Component({
  selector: 'app-t-multiple-choice',
  templateUrl: './t-multiple-choice.component.html',
  styleUrls: ['./t-multiple-choice.component.css']
})
export class TMultipleChoiceComponent extends GeneralTeacherComponent {

  private TYPE_WORD_TREE: string = "wordTree";
  private TYPE_COLOR_TREE: string = "colorTree";
  private TYPE_NO_TREE: string = "noTree";
  private treeService: TreeService;

  //Standard fields
  answers: string[] = ["", ""];
  answerType: string = "checkbox";
  private solutionCode: string;
  checkedRadio: number;
  checkedBox: boolean[] = [false, false];
  answerLength: number = 2;


  //Tree Attributes
  private readonly canvasID: string = 'graph-canvas';
  private canvas: HTMLCanvasElement = null;
  treeType: string = this.TYPE_NO_TREE;
  hasRepetition: string = 'false';
  graph: Graph; //Graph we want to display

  //Button fields
  private generateTreeButton: HTMLButtonElement = null;
  private hideContentButton: HTMLButtonElement = null;
  private deleteNodeButton: HTMLButtonElement = null;
  private highLightNodeButton: HTMLButtonElement = null;
  private selectSubTreeButton: HTMLButtonElement = null;
  private backButton: HTMLButtonElement = null;
  //private selectTreeTypeList: HTMLSelectElement = null;

  private readonly generateTreeID: string = 'generateTree';
  private readonly hideContentID: string = 'hideContent';
  private readonly deleteNodeID: string = 'deleteNode';
  private readonly highLigthID: string = 'highLight';
  private readonly selectSubTreeID: string = "selectSubTreeNode";
  private readonly backButtonID: string = "backButton";
  //private readonly selectTreeTypeID: string = "selectTreeType";

  //colorTreeAttribute
  colorNumber: number = 1;
  colorDepth: number = 1;
  color1: string = "";
  color2: string = "";
  color3: string = "";
  color4: string = "";
  color5: string = "";

  //wordTreeAttribute
  alphabetCount: number = 0; //Count of alphabet
  alphabet1: string = "";
  wordLength1: number = 0;

  alphabet2: string = "";
  wordLength2: number = 0;

  alphabet3: string = "";
  wordLength3: number = 0;

  alphabet4: string = "";
  wordLength4: number = 0;

  alphabet5: string = "";
  wordLength5: number = 0;

  onDeleteNode = () => {
    if (this.graph != null) {
      if (this.graph instanceof TreeWords) {
        this.graph.setDeleteMode();
      }
      else if (this.graph instanceof ColoredFlagNoRep) {
        this.graph.selectDeleteMode(true);
      }
      else if (this.graph instanceof ColoredFlagRep) {
        this.graph.selectDeleteMode(true);
      }
    }
  }

  onHighLightNode = () => {
    if (this.graph != null) {
      if (this.graph instanceof TreeWords) {
        this.graph.setMarkedMode();
      }
      else if (this.graph instanceof ColoredFlagNoRep) {
        this.graph.selectMarkedMode(true);
      }
      else if (this.graph instanceof ColoredFlagRep) {
        this.graph.selectMarkedMode(true);
      }
    }
  }

  onSelectSubTree = () => {
    if (this.graph != null) {
      if (this.graph instanceof TreeWords) {
        this.graph.setSubTreeMode();
      }

    }

  }

  onCompleteTree = () => {
    if (this.graph != null) {
      if (this.graph instanceof TreeWords) {
        this.graph.setGraphMode();
        this.graph.update();
      }
    }
  }

  onHideNode = () => {
    if (this.graph != null) {
      if (this.graph instanceof TreeWords) {
        this.graph.setHideNodeMode();
        this.graph.update();
      } else if (this.graph instanceof ColoredFlagRep) {
        this.graph.selectHideMode(true);
      }
      else if (this.graph instanceof ColoredFlagNoRep) {
        this.graph.selectHideMode(true);
      }
    }
  }

  updateButtons = () => {
    if (this.isNoTree()) {
      this.generateTreeButton.style.visibility = "hidden";
      this.hideContentButton.style.visibility = "hidden";
      this.canvas.style.visibility = "hidden";
      this.selectSubTreeButton.style.visibility = "hidden";
      this.backButton.style.visibility = "hidden";
      this.deleteNodeButton.style.visibility = "hidden";
      this.highLightNodeButton.style.visibility = "hidden";
    }

    if (this.isColorTree()) {
      this.generateTreeButton.style.visibility = "visible";
      this.hideContentButton.style.visibility = "visible";
      this.canvas.style.visibility = "visible";
      this.deleteNodeButton.style.visibility = "visible";
      this.highLightNodeButton.style.visibility = "visible";
      this.selectSubTreeButton.style.visibility = "hidden";
      this.backButton.style.visibility = "hidden";
    }
    if (this.isWordTree()) {
      this.generateTreeButton.style.visibility = "visible";
      this.canvas.style.visibility = "visible";
      this.hideContentButton.style.visibility = "visible";
      this.deleteNodeButton.style.visibility = "visible";
      this.highLightNodeButton.style.visibility = "visible";
      this.selectSubTreeButton.style.visibility = "visible";
      this.backButton.style.visibility = "visible";
    }
  }

  setColorTree = () => {
    this.treeType = this.TYPE_COLOR_TREE;
    this.updateButtons();
  }

  
  setWordTree = () => {
    this.treeType = this.TYPE_WORD_TREE;
    this.updateButtons();
  }
  
  setNoTree = () => {
    this.treeType = this.TYPE_NO_TREE;
    this.updateButtons();
  }

  isColorTree(): boolean {
    return this.treeType == this.TYPE_COLOR_TREE;
  }

  isWordTree(): boolean {
    return this.treeType == this.TYPE_WORD_TREE;
  }

  isNoTree(): boolean {
    return this.treeType == this.TYPE_NO_TREE;
  }

  buildTree = () => {
    if (this.treeType == this.TYPE_NO_TREE) {
      return;
    }

    let hasRep: boolean = this.hasRepetition == 'true';

    if (this.treeType == this.TYPE_WORD_TREE) {
      let args: [any[], number][] = this.preprocessDataWordTree(hasRep);
      this.graph = new TreeWords(args, hasRep, this.canvas);

      if (this.graph instanceof TreeWords) {
        this.graph.buildTree();
      }
    } else {
      let colors: string[] = [this.color1, this.color2, this.color3, this.color4, this.color5];
      colors = colors.slice(0, this.colorNumber);
      if (hasRep) {
        this.graph = new ColoredFlagRep(this.colorDepth, colors, this.canvas);
        if (this.graph instanceof ColoredFlagRep) {
          this.graph.buildTree();
        }
      }
      else {
        this.colorDepth = Math.min(this.colorDepth, this.colorNumber);
        this.graph = new ColoredFlagNoRep(this.colorDepth, colors, this.canvas);
        if (this.graph instanceof ColoredFlagNoRep) {
          this.graph.buildTree();
        }
      }
    }
    if (this.graph != null) {
      this.graph.update();
    }
  }

  changeDisplayDepth = () => {

  }

  private preprocessDataWordTree(hasRepetition: boolean): [any[], number][] {
    let alphabets: string[][] = [];
    let alpLengths: number[] = [];
    let data: [any[], number][] = [];

    alphabets.push(this.alphabet1.split(","));
    alphabets.push(this.alphabet2.split(","));
    alphabets.push(this.alphabet3.split(","));
    alphabets.push(this.alphabet4.split(","));
    alphabets.push(this.alphabet5.split(","));

    if (!hasRepetition) {
      this.wordLength1 = Math.min(Number(this.wordLength1), alphabets[0].length);
      this.wordLength2 = Math.min(Number(this.wordLength2), alphabets[1].length);
      this.wordLength3 = Math.min(Number(this.wordLength3), alphabets[2].length);
      this.wordLength4 = Math.min(Number(this.wordLength4), alphabets[3].length);
      this.wordLength5 = Math.min(Number(this.wordLength5), alphabets[4].length);
    }

    alpLengths.push(Number(this.wordLength1));
    alpLengths.push(Number(this.wordLength2));
    alpLengths.push(Number(this.wordLength3));
    alpLengths.push(Number(this.wordLength4));
    alpLengths.push(Number(this.wordLength5));

    for (let i = 0; i < this.alphabetCount; i++) {
      data.push([alphabets[i], alpLengths[i]]);
    }

    return data;

  }

  ngOnInit() {
    super.ngOnInit();
    window.onload = function () { };

    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID); //Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized
    this.generateTreeButton = <HTMLButtonElement>document.getElementById(this.generateTreeID);
    this.hideContentButton = <HTMLButtonElement>document.getElementById(this.hideContentID);
    this.backButton = <HTMLButtonElement>document.getElementById(this.backButtonID);
    this.deleteNodeButton = <HTMLButtonElement>document.getElementById(this.deleteNodeID);
    this.highLightNodeButton = <HTMLButtonElement>document.getElementById(this.highLigthID);
    this.selectSubTreeButton = <HTMLButtonElement>document.getElementById(this.selectSubTreeID);
    //this.selectTreeTypeList = <HTMLSelectElement>document.getElementById(this.selectTreeTypeID);

    this.generateTreeButton.addEventListener('click', this.buildTree, false);
    this.deleteNodeButton.addEventListener('click', this.onDeleteNode, false);
    this.selectSubTreeButton.addEventListener('click', this.onSelectSubTree, false);
    this.backButton.addEventListener('click', this.onCompleteTree, false);
    this.hideContentButton.addEventListener('click', this.onHideNode, false);
    this.highLightNodeButton.addEventListener('click', this.onHighLightNode, false);

    this.updateButtons();

    /*
    window.addEventListener('click', this.updateButtons, false);
    window.addEventListener('keydown', this.updateButtons, false);
    window.addEventListener('keypress', this.updateButtons, false);
    window.addEventListener('keyup', this.updateButtons, false);
*/
   /* 
    this.selectTreeTypeList.addEventListener('click', this.updateButtons, false);
    this.selectTreeTypeList.addEventListener('keydown', this.updateButtons, false);
    this.selectTreeTypeList.addEventListener('keypress', this.updateButtons, false);
    this.selectTreeTypeList.addEventListener('keyup', this.updateButtons, false);
*/

  }

  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, treeService: TreeService) {
    super(topicService, activatedRoute);
    this.type = "multipleChoice";
    this.title = this.get("multipleChoice");
    this.treeService = treeService;
  }

  generateDefinition() {
    let definition: any = {};
    definition.title = this.title;
    definition.description = this.description;
    definition.type = this.type;
    definition.image = "./assets/images/openQuestion_white.png";
    definition.level = 2;
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.key = "dataRepresentation%positionRepresentation%";
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.typespecifics = {};

    switch (this.treeType) {
      case this.TYPE_COLOR_TREE:
        if (this.graph != null && this.graph instanceof ColoredFlagNoRep) {
          this.treeService.exportTreeOld('flag', this.graph.getSet(), this.graph.getDepth(), false, definition);
          this.treeService.exportHiddenNodes(this.graph.getHiddenNodesAsNodes(), definition);
          this.treeService.exportMarkedNodes(this.graph.getMarkedNodes(), definition);
          this.treeService.exportDeletedNodes(this.graph.getDeletedNodes(), definition);
        }
        if (this.graph != null && this.graph instanceof ColoredFlagRep) {
          this.treeService.exportTreeOld('flag', this.graph.getSet(), this.graph.getDepth(), true, definition);
          this.treeService.exportHiddenNodes(this.graph.getHiddenNodesAsNodes(), definition);
          this.treeService.exportMarkedNodes(this.graph.getMarkedNodes(), definition);
          this.treeService.exportDeletedNodes(this.graph.getDeletedNodes(), definition);
        }
        break;
      case this.TYPE_WORD_TREE:
        if (this.graph != null && this.graph instanceof TreeWords) {
          this.treeService.exportTree(this.graph, definition);
          this.treeService.exportMultiHiddenContent(this.graph.getHiddenNodes(), definition);
          this.treeService.exportMultiMarkedContent(this.graph.getMarkedNodes(), definition);
          this.treeService.exportMultiDeletedContent(this.graph.getDeletedNodes(), definition);

          if (this.graph.getSubNode() != null)
            this.treeService.exportSubTreeNode(this.graph.getSubNode(), definition);
          this.graph.getDeletedNodes().forEach(c => {
          //  console.log(c);
          })
        }

        break;
      case this.TYPE_NO_TREE:
        break;
    }

    definition.typespecifics.answers = this.answers;
    definition.typespecifics.solutionCode = this.computeSolutionCode();
    definition.key = definition.key.concat(this.description, "%", definition.typespecifics.solutionCode);
    definition.typespecifics.type = this.answerType;

    definition.typespecifics.treeType = this.treeType;
    return definition;
  }

  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.configuration = this.topicService.getExerciseById(this.examId, this.id);
    this.title = this.configuration.title;
    this.description = this.configuration.description;
    this.answers = this.configuration.typespecifics.answers;
    this.answerLength = this.answers.length;
    this.answerType = this.configuration.typespecifics.type;
    this.solutionCode = this.configuration.typespecifics.solutionCode;
    let countCorrectAnswers: number = 0;
    let solution = new Set();
    let primes: number[] = [7, 11, 13, 17, 19];
    for (let prime of primes) {
      if (+this.solutionCode.charAt(prime) % 2 == 0) {
        countCorrectAnswers++;
      } else {
        break;
      }
    }
    // get IDs of correct solutions
    for (let p of this.createArray(countCorrectAnswers)) {
      solution.add(+this.solutionCode.charAt((p + 1) * (countCorrectAnswers)));
    }
    if (this.answerType == "checkbox") {
      this.checkedBox = new Array(this.answerLength).fill(false);
      for (let s of Array.from(solution)) {
        let str: string = <string>s;
        this.checkedBox[str] = true;
      }
    } else {
      this.checkedRadio = +this.solutionCode[1];
    }

    let resTreeType: string = this.treeService.importTreeType(this.configuration);
    if (resTreeType == this.TYPE_NO_TREE)
      return;

    this.canvas = <HTMLCanvasElement>document.getElementById(this.canvasID);
    let hasRep: boolean = this.treeService.importHasRepetition(this.configuration);

    if (resTreeType == this.TYPE_COLOR_TREE) {
      /*Call this on ngOnInit(), the constructor can't reference it, since it hasn't been initialized*/
      let alphabet: any[] = this.treeService.importTreeOld(this.configuration)[0];
      let depth: number = this.treeService.importTreeOld(this.configuration)[1];

      this.colorDepth = depth;
      this.colorNumber = alphabet.length;
      for (let i = 0; i < alphabet.length; i++) {
        switch (i) {
          case 0: this.color1 = alphabet[0]; break;
          case 1: this.color2 = alphabet[1]; break;
          case 2: this.color3 = alphabet[2]; break;
          case 3: this.color4 = alphabet[3]; break;
          case 4: this.color5 = alphabet[4]; break;
        }
      }
    }
    else {
      let alphabet: [any[], number][] = this.treeService.importMultiTree(this.configuration);
      this.alphabetCount = alphabet.length;
      for (let i = 0; i < this.alphabetCount; i++) {
        let str: string = "";
        if (i == 0) {
          alphabet[i][0].forEach(elem => {
            str = str + "," + elem;
          })
          this.alphabet1 = str.substr(1);
          this.wordLength1 = alphabet[i][1];
        }
        else if (i == 1) {
          alphabet[i][0].forEach(elem => {
            str = str + "," + elem;
          })
          this.alphabet2 = str.substr(1);
          this.wordLength2 = alphabet[i][1];
        }
        else if (i == 2) {
          alphabet[i][0].forEach(elem => {
            str = str + "," + elem;
          })
          this.alphabet3 = str.substr(1);
          this.wordLength3 = alphabet[i][1];
        }
        else if (i == 3) {
          alphabet[i][0].forEach(elem => {
            str = str + "," + elem;
          })
          this.alphabet4 = str.substr(1);
          this.wordLength4 = alphabet[i][1];
        }
        else if (i == 4) {
          alphabet[i][0].forEach(elem => {
            str = str + "," + elem;
          })
          this.alphabet5 = str.substr(1);
          this.wordLength5 = alphabet[i][1];
        }
      }
    }
    this.hasRepetition = "" + hasRep;

    this.treeType = resTreeType;
    this.buildTree();

    switch (this.treeType) {
      case this.TYPE_COLOR_TREE: this.initColoredFlag(); break;
      case this.TYPE_WORD_TREE: this.initWordTree(); break;
    }

    this.graph.update();


  }
  private initColoredFlag() {
    let hiddenContent: any[][] = this.treeService.importHiddenNodes(this.configuration);
    this.graph.getNodes().forEach(node => {
      if (node instanceof TreeNode) {
        let n: TreeNode = <TreeNode>node;
        let realContent = n.getContent();
        hiddenContent.forEach(content => {
          let hasSameContent: boolean = this.sameContent(realContent, content);
          if (hasSameContent) {
            n.setHidden(true);
          }
        })
      }
    })
    let deletedContent: any[][] = this.treeService.importDeletedNodes(this.configuration);
    this.graph.getNodes().forEach(node => {
      if (node instanceof TreeNode) {
        let n: TreeNode = <TreeNode>node;
        let realContent = n.getContent();
        deletedContent.forEach(content => {
          let hasSameContent: boolean = this.sameContent(realContent, content);
          if (hasSameContent) {
            if (this.graph instanceof ColoredFlagNoRep) {
              this.graph.deleteNode(n);
            }
            if (this.graph instanceof ColoredFlagRep) {
              this.graph.deleteNode(n);
            }
          }
        })
      }
    })
    let markedContent: any[][] = this.treeService.importMarkedNodes(this.configuration);
    this.graph.getNodes().forEach(node => {
      if (node instanceof TreeNode) {
        let n: TreeNode = <TreeNode>node;
        let realContent = n.getContent();
        markedContent.forEach(content => {
          let hasSameContent: boolean = this.sameContent(realContent, content);
          if (hasSameContent) {
            n.selected();
          }
        })
      }
    })
  }
  private initWordTree() {
    let subNodeContent: any[] = this.treeService.importSubNode(this.configuration);
    let hiddenContent: any[][] = this.treeService.importHiddenNodes(this.configuration);
    let deletedContent: any[][] = this.treeService.importDeletedNodes(this.configuration);
    let markedContent: any[][] = this.treeService.importMarkedNodes(this.configuration);


    if (this.graph instanceof TreeWords) {
      this.graph.setDeletedNodes(deletedContent);
      this.graph.setHiddenNodes(hiddenContent);
      this.graph.setMarkedNodes(markedContent);
      this.graph.setSubNode(subNodeContent);
    }
  }

  private sameContent(realContent: any[], content: any[]): boolean {
    let hasSameContent: boolean = true;
    hasSameContent = content.length == realContent.length;

    let i: number = 0;
    for (i = 0; i < content.length; i++) {
      hasSameContent = hasSameContent && (content[i] == realContent[i]);
    }
    return hasSameContent;
  }

  reset() {
    super.reset();
    this.answers = [];
    this.answerType = "checkbox";
    this.title = this.get("multipleChoice");;
    this.description = "";
    this.id = undefined;
    this.answerLength = 2;
    this.checkedBox = [false, false];
    this.checkedRadio = undefined;
  }

  /** computes the solution code based on correct answers */
  computeSolutionCode(): string {
    let solution: string = "";
    let primes: number[] = [7, 11, 13, 17, 19];
    let correntAnswerCount = this.checkedBox.filter((value) => value).length;
    if (this.answerType == "radio") {
      correntAnswerCount = 1;
    }
    let ids = this.checkedBox.map((value, index) => [value, index]).filter((value) => (value[0])).map((value) => value[1]);
    if (this.answerType == "radio") {
      ids = [this.checkedRadio];
    }
    for (let i = 0; i < 30; i++) {
      let next = Math.floor(Math.random() * 10)
      // if in the series of ids, set next as id
      if (i % correntAnswerCount == 0) {
        if (i <= correntAnswerCount * (correntAnswerCount) && i >= correntAnswerCount) {
          next = <number>ids[i / correntAnswerCount - 1];
        }
      }
      // if one of the primes, set accordingly
      let pindex = primes.indexOf(i);
      if (pindex != -1) {
        if (pindex < correntAnswerCount) {
          if (next % 2 != 0) {
            next--;
          }
        } else {
          if (next % 2 == 0) {
            next++;
          }
        }
      }
      solution = solution.concat(next.toString());
    }
    return solution;
  }

  /** adds a new answer */
  addAnswer() {
    if (this.answerLength == 5) {
      return;
    }
    this.answers.push("");
    this.checkedBox.push(false);
    this.answerLength++;
  }

  /**
   * deletes the given answer
   * @param id - answer to delete
   */
  deleteAnswer(id: number) {
    if (this.answerLength == 2) {
      return;
    }
    this.answers.splice(id, 1);
    this.checkedBox.splice(id, 1);
    if (this.checkedRadio == id) {
      this.checkedRadio == undefined;
    }
    this.answerLength--;
  }

}
